import { FC } from 'react'
import router from 'next/router'
import { Text } from '@/client/components'
import * as S from './styles'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PostTag: FC<any> = ({ tags }) => (
  <>
    <S.PostTagWrapper>
      {tags &&
        tags.length > 0 &&
        tags.map((e, index) => (
          <S.PostTag
            tagType={e['label'] || 'Sustainability'}
            onClick={() => router.push(`/blog/tag/${e['value']}`)}
            key={index}
          >
            <Text as='span' size='sm' color='inverse' family='text' weight='medium' style={{ margin: '0' }}>
              {e['label']}
            </Text>
          </S.PostTag>
        ))}
    </S.PostTagWrapper>
  </>
)
